// src/hooks/useUtente.js
import { useState, useEffect } from 'react';

const useUtente = () => {
    const [utente, setUtente] = useState(null);

    useEffect(() => {
        const mU = sessionStorage.getItem('mU');
        if (mU) {
            try {
                setUtente(JSON.parse(mU));
            } catch (e) {
                console.error("Errore parsing sessionStorage:", e);
                setUtente(null);
            }
        }
    }, []);

    return utente;
};

export default useUtente;
